module.exports = __webpack_public_path__ + "static/develop-a95bd5676a467c5904b2ba3e29e1cc65.jpg";